import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../api/index';
import ToastUtils from '../../utils/toast';

import PackageSettingsCard from '../Cards/PackageSettingsCard';

const AddPackageModal = ({ isOpen, onClose, onPackageCreated, flowData, userData }) => {
  const [loading, setLoading] = useState(false);
  const [availablePackages, setAvailablePackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [limit, setLimit] = useState(100);
  const [noWeekend, setNoWeekend] = useState(false);

  useEffect(() => {
    const loadPackages = async () => {
      try {
        const response = await apiRequest('paks', 'GET');
        const allPackages = response.data || [];
        
        // Получаем id пакетов из flowData.pakets
        const flowPackageIds = flowData?.pakets?.map(pkg => pkg.paks_id) || [];
        
        // Фильтруем: оставляем только те пакеты, paks_id которых отсутствует в flowData.pakets
        const packagesForFlow = allPackages.filter(pkg => !flowPackageIds.includes(pkg.id));
        
        setAvailablePackages(packagesForFlow);
        setSelectedPackage(packagesForFlow.length > 0 ? packagesForFlow[0] : null);
      } catch (error) {
        console.error('Ошибка при загрузке пакетов:', error);
      }
    };

    if (isOpen) {
      loadPackages();
    }
  }, [isOpen, flowData]);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!selectedPackage) {
      ToastUtils.error('Нет доступных пакетов');
      return;
    }

    if (!flowData?.integration_id) {
      ToastUtils.error('ID интеграции не найден');
      return;
    }

    setLoading(true);
    try {
      const regions = selectedRegions.map(region => region.id) || [];
      const response = await apiRequest(`/pakets/${userData.id}/add`, 'POST', {

        flow_guide_id: flowData.flow_guide_id,
        integration_id: flowData.integration_id,
        paks_id: selectedPackage.id,
        limit,
        regions: regions,
        holiday_send: noWeekend || false
      });
      
      ToastUtils.success('Пакет успешно добавлен');
      
      if (onPackageCreated) {
        await onPackageCreated();
      }
      
      onClose();
    } catch (error) {
      console.error('Ошибка при добавлении пакета:', error);
      ToastUtils.error('Ошибка при добавлении пакета');
    } finally {
      setLoading(false);
    }
  };

  const availablePackageName = availablePackages.length === 1 ? availablePackages[0].paks_name : (selectedPackage?.paks_name || '');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal small bottom-right open" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Добавить пакет: {availablePackageName}</h3>
        </div>
        <div className="modal-body">
          {selectedPackage && (
            <PackageSettingsCard
              pkg={selectedPackage}
              selectedRegions={selectedRegions}
              onRegionsChange={setSelectedRegions}
              limit={limit}
              onLimitChange={setLimit}
              noWeekend={noWeekend}
              onNoWeekendChange={setNoWeekend}
            />
          )}
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Добавление...' : 'Добавить'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPackageModal;
